module.exports = __webpack_public_path__ + "img/step3_2.03964152.jpg";